module.exports = __webpack_public_path__ + "img/su-icon-quxiaoup.a8731f24.svg";